import { Expose } from 'class-transformer';
import { Facility } from '@/models/facility';

export class SelectFacilityProps {
  @Expose()
  title?: string;
  @Expose()
  value!: Facility | null;
  @Expose()
  cityLabel?: string;
  @Expose()
  cityPlaceholder!: string;
  @Expose()
  facilityPlaceholder?: string;
  @Expose()
  facilityLabel?: string;
  @Expose()
  selectedFacilityLabel?: string;
  @Expose()
  changeFacilityButtonText?: string;
  @Expose()
  showChangeButton?: boolean;
  @Expose()
  elementType!: string;
}
